const SingleUserReport = {
  generateReport : function (user_id,courses, template){
    if (!!!user_id){
        alert("Please select a user to generate report");
        return;
    } 
    if (courses.length == 0){
        alert("Please select a course to generate report");
        return;
    }
    const form = $('<form>', {
        action: '/reports/single_user_report',
        method: 'POST'
    });
    $.each({
        courses: courses.join(","),
        user: user_id,
        template: template,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")        
    }, function(key, val) {
         $('<input>').attr({
             type: "hidden",
             name: key,
             value: val
         }).appendTo(form);
    });
    form.appendTo('body').submit();
    form.remove();
  },
  generatePdfReport: function(user_id,courses, template){
    if (!!!user_id){
        alert("Please select a user to generate report");
        return;
    } 
    if (courses.length == 0){
        alert("Please select a course to generate report");
        return;
    } 
    const form = $('<form>', {
        action: '/reports/single_user_report',
        method: 'POST'
    });
    $.each({
        courses: courses.join(","),
        user: user_id,
        template: template,
        pdf: true,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
    }, function(key, val) {
         $('<input>').attr({
             type: "hidden",
             name: key,
             value: val
         }).appendTo(form);
    });
    form.appendTo('body').submit();
    form.remove();
  },
  downloadEssays: function(user_id,courses){
    const form = $('<form>', {
        action: '/reports/single_user_report',
        method: 'POST'
    });
    $.each({
        courses: courses,
        user: user_id,
        template: "detailed",
        pdf_essays_download: true,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
    }, function(key, val) {
         $('<input>').attr({
             type: "hidden",
             name: key,
             value: val
         }).appendTo(form);
    });
    form.appendTo('body').submit();
    form.remove();
  },
  downloadPhotoWallAsZip: function(user_id,courses){
    const form = $('<form>', {
        action: '/reports/single_user_report',
        method: 'POST'
    });
    $.each({
        courses: courses,
        user: user_id,
        template: "detailed",
        zip: true,
        authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
    }, function(key, val) {
         $('<input>').attr({
             type: "hidden",
             name: key,
             value: val
         }).appendTo(form);
    });
    form.appendTo('body').submit();
    form.remove();
  }
};

function registerUserSelectEvent() {
    
    if ($("#single_user_report_errors").length > 0) {
        alert($("#single_user_report_errors").val());
    }
    
    $("#download_photowall").click(function(e){
        e.preventDefault();
        SingleUserReport.downloadPhotoWallAsZip($("#user_id").val(),$("#course_ids").val());
    });

    $("#download_single_user_essays").click(function(e){
        e.preventDefault();
        SingleUserReport.downloadEssays($("#user_id").val(),$("#course_ids").val());
    });
    
    
    $('input[id^="single_user_"]').on('click', function (event){
        $("#users-courses-select").hide(); 
        $("#users-select").css("opacity", ".2");
        $("#users-select").css("pointer-events", "none");
        $("#users-search").css("opacity", ".2");
        $("#users-search").css("pointer-events", "none");

        $.get('/reports/user_courses.json?user_id=' + $(event.target).attr("id").split("_")[$(event.target).attr("id").split("_").length-1]).done(function (courses) {
            $(".course_radio_btn").remove();
            $(".generate-btns").children().css("opacity", ".2");
            $(".generate-btns").children().css("pointer-events", "none");
            if(courses.length > 0){
               courses.forEach(function(course,index){
                let course_image = null;

                if(!!course.asset_library_image_url){
                    course_image = course.asset_library_image_url;
                }else if(!!course.image.url){
                    course_image = course.image.url;
                } else {
                    course_image = '/assets/default-image.png';
                }
                const course_template = 
                  "<div class='sdcs-select-course course_radio_btn'>\
                    <div class='bp-poster'>\
                      <div class='bp-poster-image'><img src='"+course_image+"' /></div>\
                      <div class='poster-overlay'></div>\
                    </div>\
                    <div class='smdc-course-radio left'>\
                      <input id='course_"+course.id+"' name='courses' value='"+course.id+"' type='checkbox'>\
                      <div class='check'></div>\
                      <label for='course_"+course.id+"'>"+course.name+"</label>\
                    </div>\
                  </div>";

                    $("#users-courses").append(course_template);
                });
                $("#users-courses-select").show();
                $("input[id^='course_']").click(function(){
                    $(".generate-btns").children().css("opacity", "1");
                    $(".generate-btns").children().css("pointer-events", "all");
                });
                $("#generate_report").click(function(e){
                    e.preventDefault();
                    const user_id = $("input[name='user']:checked").val();
                    const courses = [];
                    $("input[name='courses']:checked").each(function(){
                      courses.push($(this).val());  
                    });
                    SingleUserReport.generateReport(user_id,courses, "detailed");
                });
                $("#export_report_to_pdf").click(function(e){
                    e.preventDefault();
                    const user_id = $("input[name='user']:checked").val();
                    const courses = [];
                    $("input[name='courses']:checked").each(function(){
                      courses.push($(this).val());
                    });
                    SingleUserReport.generatePdfReport(user_id,courses, "detailed");
                });
            }

            $("#users-select").css("opacity", "1");
            $("#users-select").css("pointer-events", "all");
            $("#users-search").css("opacity", "1");
            $("#users-search").css("pointer-events", "all");
        });
  });
}

$(document).ready(function(){
  
  registerUserSelectEvent();
  
  $("input[id^='progress_value_']").each(function(){
      showCircleChart("progress_chart_"+$(this).attr('id').split('_')[2],parseInt($(this).val()),"Progress");
  });
  
  $("input[id^='score_value_']").each(function(){
      showCircleChart("score_chart_"+$(this).attr('id').split('_')[2],parseInt($(this).val()),"Score");
  });
  
  $(".reporting-course-tabs").each(function(){
      if($(this).children("li").length == 1){
          $(this).hide();
          $(".reporting-course-heading").hide();
      }
  });
  
   setTimeout(function(){
    $("div[id^='progress-score-tabs']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='evaluations-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='evaluations-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='answers-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='assignments-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='photowall-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='progress-summary-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
    $("div[id^='checklists-tabs-']").each(function(){
        $(this).removeClass("ui-widget-content");
    });
  }, 1000);
  
  $(".reporting-course-tooltips").tooltip();
  
  $("#search-users").keyup(function(){
      if (!!document.user_typing)
        clearTimeout(document.user_typing);
        delete document.user_typing;
      document.user_typing = setTimeout(function(){
         $.get('/reports/users?search=' + $("#search-users").val()).done(function(users){
             if(users.length > 0){
                $("div[id^='user-details-']").remove();
                 for(let i = 0; i < users.length; i = i + 1){
                    const user = users[i];
                    const user_template = 
                    "<div class='user-details' id='user-details-"+user.id+"'>\
                      <div class='smdc-radio left'>\
                        <input type='radio' name='user' value='"+user.id+"' id='single_user_"+user.id+"'>\
                        <div class='check'></div>\
                        <label for=\'single_user_"+user.id+"\'></label>\
                      </div>\
                      <div class='user-avatar'>\
                        <div class='avatar-abbriviation blue-circle'>\
                          <h5>"+user.initials+"</h5>\
                        </div>\
                        <ul>\
                          <li><h5>"+user.full_name+"</h5></li>\
                        </ul>\
                      </div>\
                    </div>";
                    $("#select_user_form").append(user_template);
                 }
                 registerUserSelectEvent();
             }
         });
      },1000);
  });
  
});
